import React from 'react';
import { Link } from "react-router-dom";
import axios from "axios";
import { Redirect } from 'react-router-dom';
import logoreg from "../abc.png";
import "../App.css";
import Path from "./config";
class RegistrationForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sbg_eng_first_name: '',
            sbg_eng_middle_name: '',
            sbg_eng_sirname: '',
            sbg_mobile_no: "",
            sbg_email_id: "",
            islogin: false,
            sbg_cpassword: '',
            sbg_password: '',
            head_info: '',
            adminid: '',
            admin: '',
            sbg_sex: '',
            footerView: true,
            bottom_info: '',
            passwordError: false
        }

    }
    componentDidMount() {
        localStorage.setItem("show#doc123", "No");
        localStorage.setItem("ed@fgg", "YES");
        localStorage.setItem("uid", "23");
        localStorage.setItem("regid", "432");
        localStorage.setItem("show#doc12", "No");

    }

    mobileHandler = (e) => {
        document.getElementById("mobileno").innerHTML = "";
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {

            let data = e.target.value;
            if (data.length > 10) {

            } else { this.setState({ sbg_mobile_no: e.target.value }) }

        }
    }
    emailHandler = (e) => {
        this.setState
            ({ sbg_email_id: e.target.value })
    }
    checkedHandler = (e) => {
        this.setState
            ({ isCheck: e.target.value })

    }

    engnameHandler = (e) => {
        document.getElementById("sbg_eng_first_name1").innerHTML = "";

        let data = e.target.value;
        if (data.length > 20) {

        } else {
            this.setState
                ({ sbg_eng_first_name: e.target.value })
        }

    }

    engmiddlenameHandler = (e) => {
        document.getElementById("sbg_eng_middle_name1").innerHTML = "";
        let data = e.target.value;
        if (data.length > 20) {

        } else {
            this.setState
                ({ sbg_eng_middle_name: e.target.value })
        }

    }
    englastnameHandler = (e) => {
        document.getElementById("sbg_eng_sirname1").innerHTML = "";
        let data = e.target.value;
        if (data.length > 20) {

        } else {
            this.setState
                ({ sbg_eng_sirname: e.target.value })
        }
    }

    genderHandler = (e) => {
        console.log(e.target.value)
        this.setState
            ({ sbg_sex: e.target.value })
    }

    passwordHandler = (e) => {
        document.getElementById("password").innerHTML = "";
        this.setState
            ({ sbg_password: e.target.value })
    }
    cpasswordHandler = (e) => {
        document.getElementById("cpassword").innerHTML = " ";
        this.setState
            ({ sbg_cpassword: e.target.value })
    }
    checkPassword = () => {

        if (this.state.sbg_cpassword !== this.state.sbg_password) {
            document.getElementById("cpassword").innerHTML = "Passwords don't match";
            // return false;
            this.setState({ isValid: false, passwordError: true })
        }
        else {
            this.setState({ isValid: true, passwordError: false })
            //return true;
        }
    }

    checkLength = () => {
        if (this.state.sbg_password.length < 6) {
            document.getElementById("password").innerHTML = "Length : 6";
            this.setState({ isValid: false })
        }
    }
    cancleClick = () => {
        this.props.history.push(`/`);
    }
    submitClick = (e) => {
        let isValid = true;
        if (!this.state.sbg_mobile_no || this.state.sbg_mobile_no.length !== 10) {
            document.getElementById("mobileno").innerHTML = "Please Enter Mobile Number";
            isValid = false;
        }
        if (this.state.sbg_password === "") {
            document.getElementById("password").innerHTML = "Please Enter Password";
            isValid = false;
        } else if (this.state.sbg_password.length < 6) {
            document.getElementById("password").innerHTML = "Password must be more than 6 characters.";
        }

        if (this.state.sbg_cpassword === "") {
            document.getElementById("cpassword").innerHTML = "Please Enter Comfirm Password";

            isValid = false;
        }
        if (this.state.sbg_eng_first_name === "") {
            document.getElementById("sbg_eng_first_name1").innerHTML = "Please Enter First Name";
            isValid = false;
        }

        if (this.state.sbg_eng_middle_name === "") {
            document.getElementById("sbg_eng_middle_name1").innerHTML = "Please Enter Middle Name";
            isValid = false;
        }

        if (this.state.sbg_eng_sirname === "") {
            document.getElementById("sbg_eng_sirname1").innerHTML = "Please Enter Surname";
            isValid = false;
        }
        console.log(this.state.sbg_sex);


        e.preventDefault();
        let tempStr = "sbg_mobile_no=" + this.state.sbg_mobile_no +
            "&sbg_email_id=" + this.state.sbg_email_id +
            "&sbg_eng_first_name=" + this.state.sbg_eng_first_name +
            "&sbg_eng_middle_name=" + this.state.sbg_eng_middle_name +
            "&sbg_eng_sirname=" + this.state.sbg_eng_sirname +
            "&sbg_password=" + this.state.sbg_password +
            "&sbg_admin_login_id=" + this.state.adminid +
            "&sbg_sex=" + this.state.sbg_sex

        if (this.state.isCheck === "on" && isValid === true && this.state.passwordError === false) {
            axios.post(Path + `Suchi_Bride_Groom_register.php?` + tempStr)
                .then(function (response) {
                    if (response.data.Sucess === 'One Record sucessfully insereted.') {
                        localStorage.setItem("userId", response.data.sbg_id);
                        localStorage.setItem("phoneId", this.state.sbg_mobile_no);
                        this.props.history.push(`./Otpcomfirm`);
                    }
                    else if (response.data.Sucess === 'Present') {
                        alert("तुमचा मोबाइल नंबर आधीपासून अस्तित्वात आहे कृपया लॉग इन करा.");
                        this.props.history.push(`./Login`);
                    }
                    else if (response.data.Sucess === 'OTP') {
                        alert("तुमचा मोबाइल नंबर आधीपासून अस्तित्वात आहे , कृपया ओटीपी प्रमाणित करून आपल्या मोबाइल नंबरची पुष्टी करा.");
                        localStorage.setItem("userId", response.data.sbg_id);
                        localStorage.setItem("phoneId", this.state.sbg_mobile_no);
                        this.props.history.push(`./Otpcomfirm`);
                    } else if (response.data.Sucess === "blacklisted") {
                        //document.getElementById("error").innerHTML = "तुमचे अकाउंट बंद करण्यात आले आहे सुरू करण्यासाठी कृपया लेवा शुभमंगल ऑफिस ला संपर्क करावा.";
                        alert("तुमचे अकाउंट बंद करण्यात आले आहे सुरू करण्यासाठी कृपया लेवा शुभमंगल ऑफिस ला संपर्क करावा.");
                    }


                }.bind(this))

        }

        else {
            alert("कृपया अनिवार्य माहिती पूर्ण भरावी.")
        }



    }
    render() {



        if (this.state.islogin) {
            return <Redirect to="/Otpcomfirm" />;
        }

        return (
            <>
                <div className="container-fluid">

                    <span className="align-middle d-flex justify-content-center">
                        <img src={logoreg} alt="logo" style={{ width: "300px" }}></img>
                    </span>

                    <form>
                        <div className="row my-5 justify-content-center ">
                            <div className="col-md-5 border  border-5 p-3 mb-2 bg-light text-dark">
                                <div className="mb-3  ">
                                    <span className="d-block p-2 bg-danger text-white text-md-center text-capitalize">
                                        येथे नोंदणी करा !
                                    </span>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="inputEmail4" className="form-label">*  वधू/वराचे नाव (फक्त इंग्रजीत )<span id="sbg_eng_first_name1" className="text-danger p-2"></span></label>
                                    <input type="text" className="form-control" id="sbg_eng_first_name" value={this.state.sbg_eng_first_name} onChange={this.engnameHandler} placeholder="First Name" />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="putPassword4" className="form-label">*  वडिलांचे नाव (फक्त इंग्रजीत )<span id="sbg_eng_middle_name1" className="text-danger p-2"></span></label>
                                    <input type="text" value={this.state.sbg_eng_middle_name} id="sbg_eng_middle_name" onChange={this.engmiddlenameHandler} className="form-control" required placeholder="Middle Name" />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="putPassword4" className="form-label">* आडनाव (फक्त इंग्रजीत )<span id="sbg_eng_sirname1" className="text-danger p-2"></span> </label>
                                    <input type="text" id="sbg_eng_sirname" value={this.state.sbg_eng_sirname} onChange={this.englastnameHandler} className="form-control" required placeholder="Surname" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="putPassword4" className="form-label"> * लिंग </label> <br></br>
                                    <div className="form-check form-check-inline">
                                        <input name="sbg_sex" id="" value="Male" checked={this.state.sbg_sex === 'Male'} onChange={this.genderHandler} className="form-check-input" type="radio" />
                                        <label className="form-check-label" htmlFor="lineRadio1">पुरुष </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input name="sbg_sex" id="" value="Female" checked={this.state.sbg_sex === 'Female'} onChange={this.genderHandler} className="form-check-input" type="radio" />
                                        <label className="form-check-label" htmlFor="lineRadio2">स्त्री </label>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="formGroupExampleInput" className="form-label">* मोबईल नंबर (फक्त 10 आकडी मोबाईल नंबर) <span id="mobileno" className="text-danger p-2"></span></label>
                                    <input type="text" className="form-control" value={this.state.sbg_mobile_no} onChange={this.mobileHandler} placeholder="Mobile Number" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="formGroupExampleInput2" className="form-label">ई मेल आय डी </label><span id="email" className="text-danger p-2"></span>
                                    <input type="email" className="form-control" value={this.state.sbg_email_id} onChange={this.emailHandler} placeholder="Email Address" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="formGroupExampleInput" className="form-label">* पासवर्ड (या ठिकाणी फक्त 6 अंकी पासवर्ड सेट करावा.) <span id="password" className="text-danger p-2"></span></label>
                                    <input type="password" autoComplete="on" maxLength="6" className="form-control" onBlur={this.checkLength} value={this.state.sbg_password} onChange={this.passwordHandler} placeholder="Password" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="formGroupExampleInput2" className="form-label">* पासवर्ड पुन्हा टाकावा</label><span id="cpassword" className="text-danger p-2"></span>
                                    <input type="password" autoComplete="on" maxLength="6" className="form-control" value={this.state.sbg_cpassword} onChange={this.cpasswordHandler} onBlur={this.checkPassword} placeholder="Confirm Password" />
                                </div>

                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" checked={this.state.isCheck}
                                        onChange={this.checkedHandler} style={{
                                            appearance: "none", // remove default radio styling
                                            WebkitAppearance: "none",
                                            MozAppearance: "none",
                                            width: "20px",
                                            height: "20px",
                                            border: "2px solid #000", // dark border

                                            outline: "none",
                                            cursor: "pointer",
                                            position: "relative",
                                        }} />
                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                        {/* <a href="http://levashubhmangal.com/web_service_14072020/leva_shubhmangal_privacy_policy.html" target="_blank" rel="noreferrer">मला सर्व नियम, अटी आणि सूचना मान्य आहेत आणि राहतील.</a> */}

                                        <Link to={`/TermsAndCondition`}> मला सर्व नियम, अटी आणि सूचना मान्य आहेत आणि राहतील. </Link>

                                    </label>


                                </div>
                                <div className="mb-3 text-center my-5">
                                    {/* <Link to="/Otpcomfirm"> */}
                                    <button type="button" className="btn btn-success m-2" onClick={(e) => (this.submitClick) ? this.submitClick(e) : null}> Submit ⏩ </button>
                                    {/* </Link> */}
                                    <button type="button" className="btn btn-primary" onClick={() => this.cancleClick()}> Cancel ❎  </button>
                                </div>





                            </div>
                            {/* <span className="align-middle d-flex justify-content-center " >
                         <div dangerouslySetInnerHTML={{ __html: this.state.bottom_info}} style={{width: "90%"}}/>
                    </span> */}
                        </div>
                    </form>





                </div>
            </>
        )
    }
}

export default RegistrationForm

